module.exports = __webpack_public_path__ + "img/sym3.c011530c.png";